import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PATHS } from "@constants/Paths";
import { PeekScreenLoader } from "@piiqtechnologies/ui-components";
import { AuthLayout, LoginBoxLayout } from "@layouts";
const AppLayout = React.lazy(() => import("@layouts/app"));
const Home = React.lazy(() => import("@pages/home"));
const Results = React.lazy(() => import("@pages/results"));
const Dashboard = React.lazy(() => import("@pages/dashboard"));
const Login = React.lazy(() => import("@pages/login"));
const ForgotPassword = React.lazy(() => import("@pages/forgot-password"));
const SSOLoginError = React.lazy(() => import("@pages/login-error"));
const AppRoutes = () => {
    return (React.createElement(Suspense, { fallback: React.createElement(PeekScreenLoader, { layered: true }) },
        React.createElement(Routes, null,
            React.createElement(Route, { path: PATHS.HOME, element: React.createElement(Home, null) }),
            React.createElement(Route, { path: PATHS.RESULTS, element: React.createElement(Results, null) }),
            React.createElement(Route, { element: React.createElement(AppLayout, null) },
                React.createElement(Route, { element: React.createElement(LoginBoxLayout, null) },
                    React.createElement(Route, { path: PATHS.LOGIN, element: React.createElement(Login, null) }),
                    React.createElement(Route, { path: PATHS.FORGOT_PASSWORD, element: React.createElement(ForgotPassword, null) }),
                    React.createElement(Route, { path: PATHS.LOGIN_ERROR, element: React.createElement(SSOLoginError, null) })),
                React.createElement(Route, { element: React.createElement(AuthLayout, null) },
                    React.createElement(Route, { path: PATHS.DASHBOARD, element: React.createElement(Dashboard, null) }))))));
};
export default AppRoutes;
